// Stock health derived from available quantity vs the reorder point.
// out -> nothing sellable, low -> at/under reorder threshold, in -> healthy.
export function deriveStockStatus(item) {
  const available = Number(item?.available ?? 0);
  const reorder = Number(item?.reorderPoint ?? 0);

  if (available <= 0) return "out";
  if (available <= reorder) return "low";
  return "in";
}

export const STOCK_STATUS_META = {
  in: { label: "In Stock", color: "bg-[#DCFCE7] text-[#166534]" },
  low: { label: "Low Stock", color: "bg-[#ffefb0] text-[#92400E]" },
  out: { label: "Out of Stock", color: "bg-[#FECACA] text-[#991B1B]" },
  unknown: { label: "Unknown", color: "bg-[#e7e7e7] text-[#333333]" },
};
